import { render, staticRenderFns } from "./NewFeatured.vue?vue&type=template&id=e4f93d1c&"
import script from "./NewFeatured.vue?vue&type=script&lang=js&"
export * from "./NewFeatured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports